import { render, staticRenderFns } from "./RentArchive.vue?vue&type=template&id=0a0abcc8&"
import script from "./RentArchive.vue?vue&type=script&lang=js&"
export * from "./RentArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports